import React, { useEffect, useState, useContext } from 'react';
import { MyContext } from '../context/MyContext';
import { callApiPost } from '../Helper/Network';

import hyappLogo from '../resource/hyapp/logo.png';
import haccproLogo from '../resource/haccpro/logo.png'
import { Form, Icon, Button } from 'react-bulma-components';

import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { useTranslation } from '../locale/useTranslation';

function Login() {
  const { t, language, setLanguage, getLanguage } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const modeParam = queryParameters.get("mode");

  const { setLoggedUser, setConstants, setEtablissements, setSelectedEtablissement } = useContext(MyContext);

  const handleLogin = async () => {
    try {
      const response = await callApiPost("/login", {
        email: email,
        password: password
      });

      //store logged user, associated constants and etablissements if exist
      setLoggedUser(response.utilisateur);
      sessionStorage.setItem("user", JSON.stringify(response.utilisateur));
      setConstants(response.constants);
      sessionStorage.setItem("constants", JSON.stringify(response.constants));
      if (response.etablissement !== undefined) {
        setEtablissements(response.etablissement);
        sessionStorage.setItem("etablissements", JSON.stringify(response.etablissement));
        if (response.etablissement.length === 1) {
          setSelectedEtablissement(response.etablissement[0]);
          sessionStorage.setItem("selectedEtablissement", JSON.stringify(response.etablissement[0]));
        }
      }

      //for superadmin and hyapp admin, display etablissement
      if (response.utilisateur.role_role_id === 0 || response.utilisateur.role_role_id === 10) {
        navigate("/etablissement");
      }
      else {
        navigate("/etablissement");
      }
    }
    catch (error) {
    }
  };

  useEffect(() => {
    //do Nothing
  }, []);


  const handleValidate = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      handleLogin();
    }
  };

  return (
    <div className="container is-centered">
      <div className="columns is-centered">
        <div className="column is-12-mobile is-6-tablet is-6-desktop">
          <div style={{textAlign: 'center', marginTop: '20px'}}>
            {
              process.env.REACT_APP_APP_VARIANT === "hyapp" ? <img src={hyappLogo} width="200px" alt="Logo HyAPP" /> : null
            } 
            {
              process.env.REACT_APP_APP_VARIANT === "haccpro" ? <img src={haccproLogo} width="300px" alt="Logo HACCPro" /> : null
            }             
          </div>

          {
            modeParam === "APP" ? <span style={{color:'red'}}>{t("Vous venez de réinitialiser votre mot de passe depuis l'application mobile, pensez à la relancer avant de vous connecter")}<br /><br /></span>: null
          }

          <div className="box" style={{ maxWidth: "400px", margin: "0 auto" }}>
          <h3 className="title is-5">{t("Se connecter")}</h3>

            {/* Email */}
            <div className="field">
              <label className="label required">{t("E-mail")}</label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  name="email"
                  placeholder={t("E-mail")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            {/* Mot de passe */}
            <div className="field">
              <div className="is-flex is-justify-content-space-between">
                <label className="label required">{t("Mot de passe")}</label>
              </div>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  name="password"
                  placeholder={t("Mot de passe")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleValidate}
                />
              </div>
            </div>

          <Button.Group style={{justifyContent: 'center'}}>
            <Button color="black" onClick={handleLogin}>
            <Icon align="left"  style={{marginRight: "0px", marginLeft: "0px"}}>
                <i className="fa fa-user"/>
              </Icon>
              {t("Se connecter")}</Button>
          </Button.Group>
            <div className="field" style={{textAlign: "right"}}>
            <Link
                  to="/forgotten"
                  className="is-size-7"
                  style={{ color: "#008080" }}
                >
                  {t("Mot de passe oublié ou première connexion ?")}
                </Link>
              <br />
            <Link target="_blank" to={"https://normechaccpro.zendesk.com/"} className="is-size-7" style={{ color: "#008080" }}>{t("Aide")}</Link>

            </div>          
        </div>
        </div>
      </div>
    </div>
  );
}
            //<Link to="/import" className="is-size-7">Importer</Link>
export default Login;